import { TransactionSuccessToast } from "@/components";
import { type TokenId, type TransactionHash, TOKEN_IDS } from "@/types";
import { ToastDetailRow } from "@/components";

interface MintSuccessToastProps {
    mintAmount: number;
    mintTokenId: TokenId;
    transactionHash: TransactionHash;
    onClose?: () => void;
}

export function MintSuccessToast({ mintAmount, mintTokenId, transactionHash, onClose }: MintSuccessToastProps) {
    return (
        <TransactionSuccessToast title="Mint successful" transactionHash={transactionHash} onClose={onClose}>
            <ToastDetailRow label="Deposited" amount={mintAmount} tokenId={mintTokenId} />
            <ToastDetailRow label="Received" amount={mintAmount} tokenId={TOKEN_IDS.IUSD} />
        </TransactionSuccessToast>
    );
}
